/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { environmentsCreateEnvironment } from "../funcs/environments-create-environment.js";
import { environmentsDeleteEnvironment } from "../funcs/environments-delete-environment.js";
import { environmentsGetEnvironment } from "../funcs/environments-get-environment.js";
import { environmentsListEnvironments } from "../funcs/environments-list-environments.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import * as environments from "../models/environments/index.js";
import * as interactions from "../models/interactions/index.js";
import {
  DeleteEnvironmentParams,
  GetEnvironmentParams,
  ListEnvironmentsParams,
} from "../models/operations/method-params.js";
import { APIPromise, unwrapAsAPIPromise } from "../types/async.js";

export class Environments extends ClientSDK {
  /**
   * Creates an environment.
   */
  createEnvironment(
    body: environments.CreateEnvironmentRequest,
    api_version?: string | undefined,
    options?: RequestOptions,
  ): APIPromise<environments.Environment> {
    return unwrapAsAPIPromise(environmentsCreateEnvironment(
      this,
      body,
      api_version,
      options,
    ));
  }

  /**
   * Lists environments.
   */
  listEnvironments(
    params?: ListEnvironmentsParams,
    options?: Omit<RequestOptions, "extra_body">,
  ): APIPromise<environments.ListEnvironmentsResponse> {
    return unwrapAsAPIPromise(environmentsListEnvironments(
      this,
      params?.api_version,
      params?.page_size,
      params?.page_token,
      options,
    ));
  }

  /**
   * Gets an environment.
   */
  getEnvironment(
    id: string,
    params?: GetEnvironmentParams,
    options?: Omit<RequestOptions, "extra_body">,
  ): APIPromise<environments.Environment> {
    return unwrapAsAPIPromise(environmentsGetEnvironment(
      this,
      id,
      params?.api_version,
      options,
    ));
  }

  /**
   * Deletes an environment.
   */
  deleteEnvironment(
    id: string,
    params?: DeleteEnvironmentParams,
    options?: Omit<RequestOptions, "extra_body">,
  ): APIPromise<interactions.Empty> {
    return unwrapAsAPIPromise(environmentsDeleteEnvironment(
      this,
      id,
      params?.api_version,
      options,
    ));
  }
}
